import { useContext, createContext } from 'react';
import { ApplicationsProps } from '../../page/Applications/type';

export interface IAppContext extends ApplicationsProps {
  isAuthenticated: boolean;
}

export const AppContext = createContext<IAppContext>({
  isAuthenticated: false,
  user: null,
  apps: null,
  isOpenVPNEnabled: false,
});

export const useAppContext = () => {
  return useContext(AppContext);
};
